import type { ConsoleDemoResetResponse } from "@redipos/contracts";
import { http } from "../../shared/http.js";

/**
 * Deliberadamente aislado — nunca se importa desde otro módulo. Ver
 * docs/analisis/consola-admin-rediseno.md §4.6: esto es la herencia de
 * "herramienta de desarrollo" del panel original, con su propio permiso
 * (admin:dev-tools) para que no vuelva a colarse en el dashboard principal.
 */
export const devToolsApi = {
  resetDemo: () => http.post<ConsoleDemoResetResponse>("/admin/dev-tools/reset-demo-tenant", {}),
};
